/* eslint-disable react/display-name */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@material-ui/core/Button';
import { withStyles, ThemeProvider } from '@material-ui/core/styles';
import themeSelection from './theme-selection';
import { fontWeights } from '../../material-ui-theme';

const ButtonBaseMemo = memo((props) => <ButtonBase {...props} />);

const ButtonCapitalized = withStyles({
  root: {
    fontWeight: fontWeights.medium,
    textTransform: 'capitalize',
    padding: '6px 12px',

    '&.Mui-disabled': {
      backgroundColor: 'var(--color-backgroundColors-disabled)',
      color: '#929292',
      boxShadow:
        '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    },
  },
})(ButtonBaseMemo);

const Button = memo(({ capitalized, color, className = '', ...restProps }) => {
  const ButtonComponent = capitalized ? ButtonCapitalized : ButtonBaseMemo;
  const { variant = '' } = { ...restProps };

  return (
    <ThemeProvider theme={themeSelection[color]}>
      <ButtonComponent
        className={`button-component button-component-color--${color}  button-component-variant--${variant} ${className}`}
        {...restProps}
        color="primary"
      />
    </ThemeProvider>
  );
});

Button.defaultProps = {
  color: 'default',
  capitalized: true,
};

Button.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'white',
    'default',
    'safe',
    'danger',
    'warning',
  ]),
  children: PropTypes.node.isRequired,
  capitalized: PropTypes.bool,
};

export default Button;
